import React, {useEffect, useState} from 'react';
import {Col, Container, Form, Row} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

const MsisdnSelection = (props) => {
    const [msisdns, setMsisdns] = useState(mapMsisdns(props.msisdns))
    const [selected, setSelected] = useState(null)

    const {t} = useTranslation()


    useEffect(() => {
        const mapped = mapMsisdns(props.msisdns);
        setMsisdns(mapped)
    }, [props.msisdns])

    useEffect(() => {
        props?.onChange(selected)
        // props.onChangeFull && props?.onChangeFull(msisdns.filter(x => selected.includes(x.msisdn)))
    }, [selected])


    function mapMsisdns(raw) {
        const result = []
        raw.map(msisdnRaw => {
            result.push({
                msisdn: msisdnRaw.id,
                fistName: msisdnRaw.firstName ?? "",
                middleName: msisdnRaw.middleName ?? "",
                lastName: msisdnRaw.lastName ?? "",
                fullName: msisdnRaw.fullName,
                // selected: false
            })
        })
        return result
    }
   
    // function toggleSelection(msisdn) {
    //     const selectedMsisdns = selected.find(selected => selected === msisdn)
    //     if(selectedMsisdns)
    //     {
    //         //Remove the MSISDIN from the list as it was deselected.
    //         setSelected(prev => prev.filter(selected => selected !== msisdn))
    //     }
    //     else
    //     {
    //         setSelected(prev => [...prev, msisdn])
    //     }
    // }

    // function toggleAllSelected()
    // {
    //     //If all are selected, then deselect all
    //     if(msisdns.every(x => selected.includes(x.msisdn)))
    //     {
    //         setSelected(prev => [...prev.filter(x => msisdns.includes(x))])
    //     }
    //     else
    //     {
    //         setSelected(prev => [...prev, ...new Set(msisdns.map(x => x.msisdn))])
    //     }
    // }

    return (
        <Container>
            <Row>
                <Col>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                            <th scope="col" style={{width: 50}}>
                                {/*<Form.Check type='radio' checked={msisdns.every(x => selected.includes(x.msisdn))} onChange={() => toggleAllSelected()}/>*/}
                            </th>
                            <th scope="col">{t('dialogs.name')}</th>
                            <th scope="col">MSISDN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {msisdns.map((msisdnRow, i) => {
                                return (
                                    <tr key={msisdnRow.msisdn}>
                                        <th scope="row"><Form.Check type='radio' checked={selected?.msisdn === msisdnRow.msisdn} onChange={() => setSelected(msisdnRow)}/></th>
                                        <td>{msisdnRow.fullName}</td>
                                        <td>{msisdnRow.msisdn}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row>
        </Container>
    );
};

export default MsisdnSelection;